import { useTranslation } from "react-i18next";
import { type JobRun, LogsContainer } from "~/components/job-log";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "~/components/ui";

interface CategorySchemaMigrationJobLogDialogProps {
  jobRun: JobRun | null;
  onClose: () => void;
}

export function CategorySchemaMigrationJobLogDialog({ jobRun, onClose }: CategorySchemaMigrationJobLogDialogProps) {
  const { t } = useTranslation();

  if (!jobRun) return null;

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-4xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("feature.categories.recordMigration.runLogTitle")}</DialogTitle>
          <DialogDescription className="mt-1 break-all font-mono text-12-regular text-fg-3">
            {t("model.common.id")}: {jobRun.jobRunId}
          </DialogDescription>
        </DialogHeader>
        <LogsContainer jobRun={jobRun} dryRun={jobRun.dryRun} />
      </DialogContent>
    </Dialog>
  );
}
